<template>
    <va-create-layout>
        <CouponPaymentEventCharge-form
            :title="title"
            :item="item"
        ></CouponPaymentEventCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
